<template>
  <div>
    <edit-form
      v-if="data"
      ref="edit"
      v-model="data"
      @loading="setLoading"
      @save-success="saveSuccess"
    />
  </div>
</template>

<script>
import EditForm from './Form'
import moment from 'moment'
import {successNotification} from '@/notifications'

export default {
  components: {
    EditForm,
  },

  props: {
    alert: {
      required: true,
      type: Object,
    },
  },

  metaInfo () {
    return {
      title: this.data && this.data.subject ? this.data.subject : 'Alert',
    }
  },

  data () {
    return {
      loading: false,
      timer: null,
      data: null,
      countdown: null,
      emailHtml: null,
    }
  },

  watch: {
    alert: {
      deep: true,
      handler () {
        this.data = this.alert
      },
    },
    data: {
      deep: true,
      handler () {
        this.changeCountdown()
      },
    },
  },

  mounted () {
    this.data = this.alert
    this.updateCountdown()
  },

  beforeDestroy () {
    clearInterval(this.timer)
  },

  methods: {
    updateCountdown () {
      this.changeCountdown()
      this.timer = setTimeout(this.updateCountdown, 60000)
    },

    changeCountdown () {
      if (!this.data || !this.data.send_at) {
        return ''
      }
      const sendAt = moment(this.data.send_at).toDate().getTime()
      const now = new Date().getTime()
      const t = sendAt - now

      if (t < 0) {
        return ''
      }
      const days = Math.floor(t / (1000 * 60 * 60 * 24))
      const hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60))

      this.countdown = (days > 0 ? days + 'd ' : '') + hours + 'h ' + minutes + 'm '
    },

    setData (err, data) {
      if (!err) {
        this.data = data.data
      }
    },

    setLoading (loading) {
      this.loading = loading
    },

    saveSuccess (response) {
      this.$notify(successNotification('Updated alert!'))
      this.loading = false
      this.$router.go(-1)
    },

    save () {
      this.$refs.edit.save()
    },


  },
}
</script>
